import { useUtcClock } from "../hooks/useUtcClock";
import { useCurrentUser } from "../lib/auth";
import { useTheme } from "../lib/theme/ThemeProvider";

const buildVersion = import.meta.env.VITE_BERSERKR_BUILD_VERSION ?? "0.0.0-dev";

/** NORSE / FRONTIER skin switch. Palette + lexicon swap, same engine underneath. */
function ThemeToggle() {
  const { themeId, toggleTheme, lex } = useTheme();
  const other = themeId === "norse" ? "Frontier" : "Norse";
  return (
    <button
      type="button"
      onClick={toggleTheme}
      title={`Switch to ${other} skin`}
      className="flex items-center gap-2 rounded border border-steel-dark px-2 py-0.5 text-base tracking-[0.1em] text-bone-mute transition-colors hover:border-ember-bright/60 hover:text-ember-bright"
    >
      <span className="text-bone-dim">skin //</span>
      <span className="text-bone">{lex.label}</span>
      <span className="text-bone-mute/60">&#8644; {other}</span>
    </button>
  );
}

/**
 * Top status bar - operator email, build version, live UTC clock.
 * Same pattern as the landing page's status bar; brand-consistent.
 */
function StatusBar() {
  const clock = useUtcClock();
  const user = useCurrentUser();
  return (
    <div className="relative z-10 flex items-center justify-between border-b border-steel-dark bg-black/70 px-6 py-2 font-display text-base font-light uppercase tracking-[0.1em] text-bone-mute backdrop-blur-sm">
      <div className="flex items-center gap-6">
        <span className="flex items-center gap-2">
          <span className="inline-block h-1.5 w-1.5 animate-pulse-ember rounded-full bg-ember-bright shadow-ember-glow" />
          system // operational
        </span>
        <span>grid 24/7</span>
        <span>node - raleigh</span>
        <ThemeToggle />
      </div>
      <div className="flex items-center gap-6">
        {user ? (
          <span className="flex items-center gap-2 text-bone-dim">
            <span className="text-bone-mute/70">operator //</span>
            <span className="normal-case tracking-normal text-bone">
              {user.email}
            </span>
            {user.isDev ? (
              <span className="rounded border border-ember-bright/50 px-1.5 py-0.5 text-sm tracking-[0.1em] text-ember-bright">
                dev
              </span>
            ) : null}
          </span>
        ) : null}
        <span>build {buildVersion}</span>
        <span>{clock}</span>
      </div>
    </div>
  );
}

export default StatusBar;
